import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';
import { apiKeyKeys } from '../constants';

export const useRevokeApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error>({
    mutationFn: async () => {
      await bffApiClient.delete('/api/api-keys/me');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeyKeys.me });
    }
  });
};
